// IMPORTS
// Modules
import $ from 'jquery';
import { useState, useEffect } from 'react';
// Assets
import './../scss/OHSForm.scss';


// COMPONENT
export function OHSFormItem (props) {
   // Component
   return (
      <div className='ohsform-item'>
         <p className='ohsform-item-title'>{props.title}</p>
         <div className='ohsform-item-body'>
            {props.children}
         </div>
      </div>
   );
}

export function OHSFormSubmit (props) {
   // Component
   return (
      <div className='ohsform-submit'>
         <div className='ohsform-submit-actions'>
            {props.add && <button className='ohsbtn-success' onClick={props.add}>Add</button>}
            {props.update && <button className='ohsbtn' onClick={props.update}>Update</button>}
            {props.edit && <button className='ohsbtn' onClick={props.edit}>Edit</button>}
            {props.delete && <button className='ohsbtn-error' onClick={props.delete}>Delete</button>}
            {props.clear && <button className='ohsbtn' onClick={props.clear}>Clear</button>}
            {props.custom && props.custom.length > 0 && props.custom.map(function (item, i) {
               return (
                  <button key={`ohsform-submit-custom-${i}`} className={item.class} onClick={item.action}>{item.title}</button>
               );
            })}
         </div>
         {props.keyListener &&
            <div className='ohsform-submit-keyhint'>
               <p>Press "Shift + Enter" to submit</p>
            </div>
         }
      </div>
   );
}

export function OHSFormSubmitListener (e, callback) {
   if (e.key === "Enter" && e.shiftKey) {
      e.preventDefault();
      callback();
   }
}

export function OHSFormDataExtractor (container) {
   var dict = {};
   $('#' + container + ' [data-ohsformdata]').each(function () {
      dict[$(this).data('ohsformdata')] = OHSFormDataFormatter(this, 'reference');
   });
   return JSON.stringify(dict);
}

export function OHSFormDataFormatter (object, type) {
   // Determine JQuery Type
   if (type === 'id') {
      var element = '#' + object;
   } else if (type === 'reference') {
      var element = object;
   } else {
      var element = '#' + object;
   }

   // Return Value in OHS Format
   if ($(element).attr('type') == 'checkbox') {
      // Format checkboxes
      if ($(element).is(':checked')) {
         return true;
      } else {
         return false;
      }
   } else if ($(element).attr('type') == 'number') {
      if ($(element).val() == "") {
         return null;
      } else {
         return $(element).val();
      }
   } else {
      // Format all other inputs
      return $(element).val();
   }
}

export function OHSFormDataClearer (container) {
   // Find all inputs and empty
   $('#' + container + ' input').each(function () {
      $(this).val('');
   });

   // Find all selects and empty
   $('#' + container + ' select').each(function () {
      let temp = $(this).find('option:first')[0];
      $(this).val($(temp).val());
   });

   //Find all checkboxes and empty
   $('#' + container + ' input[type="checkbox"]').each(function () {
      $(this).prop('checked', false);
   });

   // Find all text areas and empty
   $('#' + container + ' textarea').each(function () {
      $(this).val('');
   });
}

export function OHSFormSelectBuilder (props) {
   // States and Variables
   const selectID = 'ohsformselectbuilder-' + Math.floor(Math.random() * 999999);
   const [current, setCurrent] = useState(props.selected || "_OHS_BLANK_");

   // Functions
   const handleChange = function (event) {
      setCurrent(event.target.value);
      if (props.onchange) {
         props.onchange(event);
      }
   }

   // Component
   return (
      <select id={props.id || selectID} ref={props.refObject ? props.refObject : null} className='ohsinput' value={current} onChange={(event) => {handleChange(event);}} data-ohsformdata={props.ohsformdata} disabled={props.disabled}>
         {props.blank && <option value="_OHS_BLANK_">---</option>}
         {props.content && props.content.length > 0 ? props.content.map(function (item, i) {
            if (props.simple === true) {
               return (
                  <option key={`${selectID}-${i}`} value={item}>{item}</option>
               );
            } else if (props.object === true) {
               return (
                  <option key={`${selectID}-${i}`} value={item[props.objectValue]}>{item[props.objectName]}</option>
               );
            } else {
               return (
                  <option key={`${selectID}-${i}`} value={item.id.value}>{item[props.field].value}</option>
               );
            }
         }) : props.blank || <option value="_OHS_BLANK_">---</option>}
      </select>
   );
}